import { concat as _concat } from 'lodash';
import { NewProjectFormModel } from '.';
import { countriesSelectArray } from '../../Locals';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../../app/Partials/Project/NewForm/ProjectNewForm.messages';

export const newProjectFormData = (isInternalUser: boolean | undefined): NewProjectFormModel => {
	const fields: NewProjectFormModel = {
		name: {
			col: 12,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectNameError}),
			label: formatMessage({...MESSAGES.projectName}),
			name: 'name',
			type: 'text',
			placeholder: formatMessage({...MESSAGES.projectName}),
			required: true,
			validation: 'isLength',
			value: '',
		},
		street: {
			col: 6,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectStreetError}),
			label: formatMessage({...MESSAGES.projectStreet}),
			name: 'street',
			type: 'text',
			placeholder: formatMessage({...MESSAGES.projectStreet}),
			required: false,
			validation: 'isLength',
			value: '',
		},
		streetNr: {
			col: 6,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectStreetNrError}),
			label: formatMessage({...MESSAGES.projectStreetNr}),
			name: 'streetNr',
			type: 'text',
			placeholder: formatMessage({...MESSAGES.projectStreetNr}),
			required: false,
			validation: 'isLength',
			minLength: 1,
			value: '',
		},
		zip: {
			col: 6,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectZipError}),
			label: formatMessage({...MESSAGES.projectZip}),
			name: 'zip',
			type: 'text',
			placeholder: formatMessage({...MESSAGES.projectZip}),
			required: true,
			validation: 'isLength',
			value: '',
		},
		city: {
			col: 6,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectCityError}),
			label: formatMessage({...MESSAGES.projectCity}),
			name: 'city',
			type: 'text',
			placeholder: formatMessage({...MESSAGES.projectCity}),
			required: true,
			validation: 'isLength',
			value: '',
		}
	}

	if (isInternalUser) {
		fields.country = {
			col: 12,
			defaultValue: undefined,
			disabled: false,
			error: false,
			errorMessage: formatMessage({...MESSAGES.projectCountryError}),
			label: formatMessage({...MESSAGES.projectCountry}),
			name: 'country',
			type: 'select',
			placeholder: formatMessage({...MESSAGES.projectCountry}),
			required: true,
			validation: '',
			value: '',
			multiple: false,
			options: _concat(
				[], 
				[{
					label: formatMessage({...MESSAGES.projectCountryLabel}),
					value: '',
					disabled: true,
				}], 
				countriesSelectArray(isInternalUser)
			)
		}
	}

	return fields;
};
